module.exports = __webpack_public_path__ + "img/Feature.15b0c960.jpg";